




export default {
    name: 'animated_number'

    props:
        number:
            default: 0

    data: ()->
        display_number: 0
        interval: false

    ready: ()->
        if @number?
            @display_number = @number
        else
            @display_number = 0

    watch:
        number: ()->
            clearInterval(@interval)
    
            if @number == @display_number
                return
    
            self = @
            if @number > @display_number
                @interval = setInterval ()->
                    if self.display_number != self.number
                        self.display_number = self.display_number + 1
                , 400
            else
                @interval = setInterval ()->
                    if self.display_number != self.number
                        self.display_number = self.display_number - 1
                , 400
}
